import { FOOTER_TYPES, HEADER_TYPES } from 'src/consumer/constants'
import { convertPixelsToInches } from 'src/mentor/components/PrescriptionMakingPage/printComponents/utils'

export default function PrescriptionHeaderBodyFooterDebugLabels({
  prescriptionBreaks,
  a4PageWidth,
  useNewPrintUI,
  a4PageHeight,
  debugMode,
  headerStyleToShow,
  footerStyleToShow,
  prescriptionData,
  printType,
  headerHeight,
  headerDimensions,
  footerDimensions,
  patientInfoDimensions,
  marginOffsets,
  dpi,
  isLastPage,
  pageIdx,
}) {

  function renderHeaderArrow() {
    return (
      <>
        <>{/* Horizontal line with arrow and text for header */}</>
        <div
          style={{
            position: 'absolute',
            width: '1px',
            height: `${headerDimensions?.height}px`,
            top: '0px',
            right: '-10px',
            background: 'black',
          }}
        >
          {/* Arrow tip at the bottom */}
          <div
            style={{
              position: 'absolute',
              bottom: '-5px',
              left: '-4px',
              width: 0,
              height: 0,
              borderTop: '5px solid black',
              borderLeft: '4px solid transparent',
              borderRight: '4px solid transparent',
            }}
          ></div>
          {/* Text label on the right (rotated) */}
          <span
            style={{
              position: 'absolute',
              top: '50%',
              left: '10px',
              transform: 'rotate(-270deg) translateX(-50%)',
              transformOrigin: 'left center',
              fontSize: '12px',
              color: 'black',
              fontWeight: '500',
              whiteSpace: 'nowrap',
            }}
          >
            {/* Header: {headerDimensions?.height?.toFixed(2)} Px */}
            Header: {convertPixelsToInches(headerDimensions?.height, dpi)?.toFixed(2)} in
          </span>
        </div>
      </>
    )
  }

  function footerArrow() {
    return (
      <>
        <>{/* Horizontal line with arrow and text for footer */}</>
        <div
          style={{
            position: 'absolute',
            width: '1px',
            height: `${footerDimensions?.height}px`,
            bottom: '0px',
            right: '-10px',
            background: 'black',
          }}
        >
          {/* Arrow tip at the bottom */}
          <div
            style={{
              position: 'absolute',
              bottom: '-5px',
              left: '-4px',
              width: 0,
              height: 0,
              borderTop: '5px solid black',
              borderLeft: '4px solid transparent',
              borderRight: '4px solid transparent',
            }}
          ></div>
          {/* Text label on the right (rotated) */}
          <span
            style={{
              position: 'absolute',
              top: '50%',
              left: '10px',
              transform: 'rotate(-270deg) translateX(-50%)',
              transformOrigin: 'left center',
              fontSize: '12px',
              color: 'black',
              fontWeight: '500',
              whiteSpace: 'nowrap',
            }}
          >
            {/* Header: {headerDimensions?.height?.toFixed(2)} Px */}
            Footer: {convertPixelsToInches(footerDimensions?.height, dpi)?.toFixed(2)} in
          </span>
        </div>
      </>
    )
  }

  return (
    <div
      className="hide-on-print"
      style={{
        background: '#0000000d',
        paddingLeft: `${marginOffsets?.marginLeft}px`,
        paddingRight: `${marginOffsets?.marginRight}px`,
        paddingTop: `${marginOffsets?.marginTop}px`,
        paddingBottom: `${marginOffsets?.marginBottom}px`,
        height: `${a4PageHeight}px`,
        width: `${a4PageWidth}px`,
      }}
    >
      <div style={{ position: 'relative', height: '100%' }}>
        {/* HEADER INFORMATION */}
        {headerStyleToShow === HEADER_TYPES?.onAllPages ? <>{renderHeaderArrow()}</> : <></>}
        {headerStyleToShow === HEADER_TYPES?.onAlternatePages ? (
          <>{pageIdx % 2 === 0 ? <>{renderHeaderArrow()}</> : <></>}</>
        ) : (
          <></>
        )}
        {headerStyleToShow === HEADER_TYPES?.blankHeader ? <>{renderHeaderArrow()}</> : <></>}

        {/* FOOTER INFORMATION */}
        {footerStyleToShow === FOOTER_TYPES?.onAllPages ? <>{footerArrow()}</> : <></>}
        {footerStyleToShow === HEADER_TYPES?.onAlternatePages ? (
          <>{pageIdx % 2 === 0 ? <>{footerArrow()}</> : <></>}</>
        ) : (
          <></>
        )}
        {footerStyleToShow === FOOTER_TYPES?.onLastPage && isLastPage ? (
          <>{footerArrow()}</>
        ) : (
          <></>
        )}
      </div>
    </div>
  )
}
